import React, { useEffect, useRef } from 'react';
import networkImage from '../assets/network.webp';
import providerImage from '../assets/provider.webp';
import explorerImage from '../assets/explorer.webp';
import '../css/Themes.css'; 


const ThemesSection = () => {
  return (
          
    <section id="themes" className="themes-section">
      <h2>Explore AI-DePIN Features</h2>
      <div className="themes-container">
        <div className="theme-item">
          <h3>AI-DePIN Network</h3>
          <img src={networkImage} alt="AI-DePIN Network" className="theme-image" />
          <p>AI-DePIN Network enables startups and enterprises to create powerful and scalable GPU clusters, providing access to a wide array of graphics cards.</p> 
          <p>Whether you require high-end GPUs for deep learning or cost-effective options for lighter tasks, the platform provides flexible resource selection.</p> 
          <p>By leveraging decentralized infrastructure, AI-DePIN significantly reduces costs compared to traditional hosting services, making it ideal for businesses aiming to deploy AI efficiently and securely.</p>
          <a href="#ai-depin-network" className="cta-button">Learn More</a>
        </div>
        <div className="theme-item">
          <h3>AI-DePIN Provider</h3>
          <img src={providerImage} alt="AI-DePIN Provider" className="theme-image" />
          <p>Join AI-DePIN as a provider by integrating your GPUs to generate revenue through a system that seamlessly transitions between cryptocurrency mining and distributed AI computing.</p> 
          <p>Providers can easily configure their miners with an intuitive interface, and when an AI task is assigned, mining automatically pauses, resuming once the task is complete.</p> 
          <p>This dual functionality ensures continuous earnings, allowing providers to maximize returns from both mining and AI processing tasks.</p> 
          <a href="#ai-depin-provider" className="cta-button">Learn More</a>
        </div>
        <div className="theme-item">
          <h3>AI-DePIN Explorer</h3>
          <img src={explorerImage} alt="AI-DePIN Explorer" className="theme-image" />
          <p>Monitor and visualize real-time data across both the mining and GPU cluster operations within the AI-DePIN network.</p>
          <p>Detailed graphs provide in-depth insights into network performance, including processing power, uptime, and workloads. </p>
          <p>Whether focused on mining or AI processing, this feature offers complete visibility, empowering you to optimize operations and maximize rewards.</p>
          <a href="#ai-depin-explorer" className="cta-button">Learn More</a>
        </div>
      </div>
    </section>
  );
};

export default ThemesSection;
